module.exports = __webpack_public_path__ + "static/img/Winter White.1b14f07.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Winter White.jpg
// module id = oigS
// module chunks = 0